/* ============================================================
   HERO SOCKS THEME — Global JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Announcement bar close ──
  const announcementClose = document.querySelector('.announcement-bar__close');
  const announcementBar   = document.querySelector('.announcement-bar');
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', function () {
      announcementBar.style.display = 'none';
      sessionStorage.setItem('announcementClosed', '1');
    });
    if (sessionStorage.getItem('announcementClosed') === '1') {
      announcementBar.style.display = 'none';
    }
  }

  // ── Sticky header shadow on scroll ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // ── Mobile nav toggle ──
  const hamburger  = document.querySelector('.hamburger');
  const mobileNav  = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ── Live cart count ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  updateCartCount();

  // ── Product page: thumbnail gallery ──
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src.replace('_72x', '_800x');
      }
    });
  });

  // ── Product page: variant picker ──
  const variantDataEl = document.getElementById('ProductVariantData');
  if (variantDataEl) {
    const variants = JSON.parse(variantDataEl.textContent);
    const variantIdInput = document.getElementById('variant-id');
    const priceEl = document.querySelector('.product-info__price');
    const productMainImg = document.getElementById('product-main-image');
    const addToCartBtn = document.querySelector('.btn-add-to-cart');
    const selections = [];

    document.querySelectorAll('.size-options').forEach(function (group) {
      const activeBtn = group.querySelector('.size-btn.active') || group.querySelector('.size-btn');
      if (activeBtn) selections[parseInt(activeBtn.dataset.option, 10) - 1] = activeBtn.dataset.value;
    });

    function findVariant() {
      for (let i = 0; i < variants.length; i++) {
        let matches = true;
        for (let j = 0; j < variants[i].options.length; j++) {
          if (variants[i].options[j] !== selections[j]) { matches = false; break; }
        }
        if (matches) return variants[i];
      }
      return null;
    }

    function applyVariant(variant) {
      if (!variant) {
        // No variant matches this combination of options — never let a bad
        // id reach /cart/add.js, disable the button instead.
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Unavailable';
        }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (productMainImg && variant.image) {
        productMainImg.src = variant.image;
        productMainImg.srcset = variant.imageSrcset;
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    document.querySelectorAll('.size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const group = btn.closest('.size-options');
        group.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selections[parseInt(btn.dataset.option, 10) - 1] = btn.dataset.value;
        applyVariant(findVariant());
      });
    });
  }

  // ── Add to cart ──
  const addToCartForm = document.querySelector('[data-product-form]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(addToCartForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartCount();
          // simple feedback
          const btn = addToCartForm.querySelector('.btn-add-to-cart');
          if (btn) {
            const original = btn.textContent;
            btn.textContent = 'Added!';
            setTimeout(function () { btn.textContent = original; }, 1500);
          }
        })
        .catch(function () {
          alert('Something went wrong. Please try again.');
        });
    });
  }

});
